import apiClient from './apiClient';
import { useCaseService } from './useCaseService';

const apiBaseURL = '/personas/';

export interface Persona {
  id: string;
}

export const personaService = {
  /**
   * Récupère les personas associés à un cas d'usage
   * @param useCaseId - L'ID du cas d'usage
   */
  async listByUseCase(useCaseId: string): Promise<Persona[]> {
    return useCaseService.listPersonas(useCaseId);
  },

  /**
   * Met à jour les personas associés à un cas d'usage
   * @param useCaseId - L'ID du cas d'usage
   * @param payload - Les données des personas
   */
  async updateForUseCase(useCaseId: string, payload: any): Promise<void> {
    await useCaseService.updatePersonas(useCaseId, payload);
  },

  /**
   * Crée un nouveau persona
   * @param data - Les données du persona à créer
   */
  async create(data: any): Promise<Persona> {
    const response = await apiClient.post<Persona>(apiBaseURL, data);
    return response.data;
  },

  /**
   * Met à jour un persona existant
   * @param personaId - L'ID du persona
   * @param payload - Les données de mise à jour
   */
  async update(personaId: string, payload: any): Promise<Persona> {
    const response = await apiClient.put<Persona>(`${apiBaseURL}${personaId}`, payload);
    return response.data;
  },

  /**
   * Supprime un persona
   * @param personaId - L'ID du persona
   */
  async delete(personaId: string): Promise<void> {
    await apiClient.delete(`${apiBaseURL}${personaId}`);
  },

  /**
   * Upload l'avatar d'un persona
   * @param personaId - L'ID du persona
   * @param formData - Les données du formulaire contenant l'image
   */
  async uploadAvatar(personaId: string, formData: FormData): Promise<Persona> {
    const response = await apiClient.post<Persona>(`${apiBaseURL}${personaId}/avatar`, formData);
    return response.data;
  }
};

export default personaService;
